import { render } from "./FieldDetails.vue?vue&type=template&id=0ce87291"
import script from "./FieldDetails.vue?vue&type=script&lang=js"
export * from "./FieldDetails.vue?vue&type=script&lang=js"
script.render = render

export default script